// https://www.dbos.dev/compare/dbos-vs-temporal

import { SiteLayout } from '@components/layout/SiteLayout';
import { SlideIn } from '@components/interactions';
import { HighlightedCode } from '@components/interactions/CodeBlock';
import { FaqAccordion, FaqAnswer, FaqIcon, FaqQuestion } from '@components/webflow';

export function CompareDbosVsTemporalPage() {
  return (
    <SiteLayout banner={true} footerCta={null}>
      <style
        dangerouslySetInnerHTML={{
          __html:
            '.is-list-filtering {\n/* Used to fade between filtering */\n/* Timing adjusted at the wrapper level */\nopacity: 0;\n}\n\nbody, html {\n  overflow-x: hidden !important;\n}',
        }}
      />
      <style
        dangerouslySetInnerHTML={{
          __html:
            "pre {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-x: auto;\n  margin: 0 !important;\n  background: none !important;\n}\n\ncode {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  max-width: 100%;\n  display: inline-block;\n}\n\n.is-post {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n  /* Base code block */\n  pre code.hljs {\n    display: block;\n    padding: 1rem 2rem;\n    background: #090D15;\n    color: #F3F6F8;\n    font-family: var(--_ui-styles-july-2025---typography--code), Menlo, Consolas, 'Courier New', monospace;\n    overflow-x: auto;\n    font-size: 0.875rem;\n  }\n\n  /* Keywords like function, const, return */\n  .hljs-keyword,\n  .hljs-selector-tag,\n  .hljs-literal,\n  .hljs-section,\n  .hljs-class,\n  .hljs-type {\n    color: #2ED5F6; /* Neon Blue */\n  }\n\n  /* Strings, numbers, literals */\n  .hljs-number,\n  .hljs-variable,\n  .hljs-template-tag,\n  .hljs-keyword, \n  .hljs-title.function_ {\n    color: var(--color-palette--color-splice-500);\n  }\n\n  .hljs-built_in,\n  .hljs-string,\n  .hljs-subst {\n    color: var(--_color-scheme-july-2025---text);\n  }\n\n  /* Comments */\n  .hljs-comment {\n    color: var(--_color-scheme-july-2025---border-clickable);\n    font-style: italic;\n  }\n\n  /* Function names and titles */\n  .hljs-title,\n  .hljs-function,\n  .hljs-property,\n  .hljs-punctuation,\n  .hljs-operator {\n    color: var(--_color-scheme-july-2025---headings);\n  }",
        }}
      />
      <section className="section_conductor">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large padding-top">
              <div className="product_component">
                <div className="max-width-large">
                  <div className="text-align-center">
                    <div className="margin-bottom margin-xsmall">
                      <div className="tagline-container text-size-small">2026 Comparison</div>
                    </div>
                    <div className="margin-bottom margin-xsmall">
                      <h1 className="heading-style-h1">DBOS vs. Temporal</h1>
                    </div>
                    <div className="margin-bottom margin-small">
                      <p className="text-body-active">
                        DBOS is the leading Temporal alternative for teams that need durable, fault-tolerant workflows
                        without adding high operational and infrastructure costs. Unlike Temporal, which requires a
                        separate orchestration server and Cassandra data cluster to host, DBOS runs as a library inside
                        your existing application and stores workflow state directly in Postgres, which makes it faster
                        to adopt, cheaper to run, and simpler to operate.
                      </p>
                    </div>
                    <div className="button-group is-center">
                      <div data-wf--button--variant="primary-large" className="button-wrapper">
                        <a href="https://console.dbos.dev/" className="button w-inline-block">
                          <div className="text-block-4">Start for free</div>
                          <div className="icon-chevron-right w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="https://calendly.com/alex-poliakov-dbos/30min"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">
                            Request a demo
                          </div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_console">
        <div className="layout_glow-container">
          <img
            src="/assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow.avif"
            loading="lazy"
            sizes="(max-width: 3999px) 100vw, 3999px"
            srcSet="/assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-500.avif 500w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-800.avif 800w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-1080.avif 1080w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-1600.avif 1600w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-2000.avif 2000w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-2600.avif 2600w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-3200.avif 3200w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow.avif 3999w"
            alt=""
            className="layout_code-glow"
          />
          <div className="layout_glow-gradient" />
        </div>
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large">
              <div className="layout-compare_gradient" />
              <div className="layout-2col_list is-pricing">
                <div id="w-node-e231a017-190b-509f-5ab2-5d1edd635629-b1c72ac9" className="layout-2col_item is-stat">
                  <h4 className="heading-style-h3">Billions</h4>
                  <p className="text-body-active text-size-regular">of durable workflows per day</p>
                </div>
                <div id="w-node-_7510b860-e6f7-4a8d-5c91-b0844c107508-b1c72ac9" className="layout-2col_item is-stat">
                  <h4 className="heading-style-h3">Zero</h4>
                  <p className="text-body-active text-size-regular">new infrastructure required</p>
                </div>
                <div id="w-node-cac395ac-502b-6112-e350-fe41cd74f7f4-b1c72ac9" className="layout-2col_item is-stat">
                  <h4 className="heading-style-h3">Zero</h4>
                  <p className="text-body-active text-size-regular">lock-in</p>
                </div>
                <div id="w-node-_0e734595-4456-b7ab-fe2f-f450fff18d27-b1c72ac9" className="layout-2col_item is-logo">
                  <div className="logo_list-wrapper w-dyn-list">
                    <div role="list" className="logo_list-collection w-dyn-items">
                      <div role="listitem" className="logo_list-item w-dyn-item">
                        <a href="/case-studies/bms" className="logo_list-link w-inline-block">
                          <img
                            src="/assets/cms/684a48c338268a5fc2bac97a_BMS-Logo.svg"
                            loading="lazy"
                            alt=""
                            height="Auto"
                            className="logo_list-logo"
                          />
                        </a>
                      </div>
                      <div role="listitem" className="logo_list-item w-dyn-item">
                        <a href="#" className="logo_list-link w-inline-block">
                          <img
                            src="/assets/cms/6a0dc63055842404afb10bfd_Notion-logo.png"
                            loading="lazy"
                            alt=""
                            height="Auto"
                            className="logo_list-logo"
                          />
                        </a>
                      </div>
                      <div role="listitem" className="logo_list-item w-dyn-item">
                        <a href="#" className="logo_list-link w-inline-block">
                          <img
                            src="/assets/cms/69e64d266dcfe6a36e0767c7_walmart-logo.png"
                            loading="lazy"
                            alt=""
                            height="Auto"
                            className="logo_list-logo"
                          />
                        </a>
                      </div>
                      <div role="listitem" className="logo_list-item w-dyn-item">
                        <a href="#" className="logo_list-link w-inline-block">
                          <img
                            src="/assets/cms/69d4b4518528e6ebe275300a_Roche.svg"
                            loading="lazy"
                            alt=""
                            height="Auto"
                            className="logo_list-logo"
                          />
                        </a>
                      </div>
                      <div role="listitem" className="logo_list-item w-dyn-item">
                        <a href="#" className="logo_list-link w-inline-block">
                          <img
                            src="/assets/cms/6a19b23a8e89f3b1180fe648_SeatGeek-logo.png"
                            loading="lazy"
                            alt=""
                            height="Auto"
                            className="logo_list-logo"
                          />
                        </a>
                      </div>
                      <div role="listitem" className="logo_list-item w-dyn-item">
                        <a href="#" className="logo_list-link w-inline-block">
                          <img
                            src="/assets/cms/692f972f7e0e5c80fdd2c6a2_Luma-AI-logo.png"
                            loading="lazy"
                            alt=""
                            height="Auto"
                            className="logo_list-logo"
                          />
                        </a>
                      </div>
                      <div role="listitem" className="logo_list-item w-dyn-item">
                        <a
                          href="/case-studies/yutori-large-scale-durable-agentic-ai"
                          className="logo_list-link w-inline-block"
                        >
                          <img
                            src="/assets/cms/69d4bc7a5d6f311045a75214_Yutori.avif"
                            loading="lazy"
                            alt=""
                            height="Auto"
                            className="logo_list-logo"
                          />
                        </a>
                      </div>
                      <div role="listitem" className="logo_list-item w-dyn-item">
                        <a href="#" className="logo_list-link w-inline-block">
                          <img
                            src="/assets/cms/6a26576fff679ec1b66fd004_Avnet-logo.png"
                            loading="lazy"
                            alt=""
                            height="Auto"
                            className="logo_list-logo"
                          />
                        </a>
                      </div>
                      <div role="listitem" className="logo_list-item w-dyn-item">
                        <a href="/case-studies/dosu" className="logo_list-link w-inline-block">
                          <img
                            src="/assets/cms/69d4bc64e48ce50044f90307_dosu.avif"
                            loading="lazy"
                            alt=""
                            height="Auto"
                            className="logo_list-logo"
                          />
                        </a>
                      </div>
                      <div role="listitem" className="logo_list-item w-dyn-item">
                        <a href="#" className="logo_list-link w-inline-block">
                          <img
                            src="/assets/cms/69fca0f55bf9e8e1d151777b_Stuut-logo.svg"
                            loading="lazy"
                            alt=""
                            height="Auto"
                            className="logo_list-logo"
                          />
                        </a>
                      </div>
                      <div role="listitem" className="logo_list-item w-dyn-item">
                        <a
                          href="/case-studies/orderful-resilient-edi-at-scale"
                          className="logo_list-link w-inline-block"
                        >
                          <img
                            src="/assets/cms/69b0d4f7613c2dba1c87abdb_Orderful-logo2.svg"
                            loading="lazy"
                            alt=""
                            height="Auto"
                            className="logo_list-logo"
                          />
                        </a>
                      </div>
                      <div role="listitem" className="logo_list-item w-dyn-item">
                        <a href="#" className="logo_list-link w-inline-block">
                          <img
                            src="/assets/cms/6a265740d597c8e6798da957_MUFG-logo2.png"
                            loading="lazy"
                            alt=""
                            height="Auto"
                            className="logo_list-logo"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_features is-compare">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-medium">
              <div className="margin-bottom margin-medium">
                <div className="text-align-center">
                  <div className="margin-bottom margin-xsmall">
                    <h2 className="tagline-container text-size-small">Why DBOS?</h2>
                  </div>
                  <div className="max-width-medium">
                    <div className="margin-bottom margin-small is-partner">
                      <h3 className="heading-style-h2">Simpler to adopt. Simper to operate.</h3>
                    </div>
                    <p className="text-body-active">
                      DBOS is a library you install, not a service you run. If you already use Postgres, you already
                      have everything you need.
                    </p>
                  </div>
                </div>
              </div>
              <div className="layout-2col_list is-pricing">
                <div id="w-node-_21703749-384c-1ad0-af87-701ea5c350b6-b1c72ac9" className="layout-2col_item">
                  <div className="margin-bottom margin-tiny">
                    <div className="w-embed">
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {'\n'}
                        <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" stroke="url(#paint0_linear_9071_5086)" />
                        {'\n'}
                        <path
                          d="M17.732 23.381V16.619C17.732 16.4492 17.8035 16.3269 17.9465 16.2523C18.0893 16.1776 18.2374 16.1859 18.3908 16.2773L23.6157 19.6332C23.7484 19.7244 23.8148 19.8467 23.8148 20C23.8148 20.1533 23.7484 20.2756 23.6157 20.3667L18.3908 23.7227C18.2374 23.8141 18.0893 23.8224 17.9465 23.7477C17.8035 23.6731 17.732 23.5508 17.732 23.381ZM10.5538 25.7962V28.237C10.5538 28.4815 10.473 28.6846 10.3115 28.8462C10.1498 29.0077 9.94675 29.0885 9.70225 29.0885C9.45758 29.0885 9.2545 29.0077 9.093 28.8462C8.93133 28.6846 8.8505 28.4815 8.8505 28.237V23.6542C8.8505 23.4097 8.93133 23.2067 9.093 23.045C9.2545 22.8835 9.45758 22.8027 9.70225 22.8027H14.2598C14.5044 22.8027 14.7075 22.8835 14.869 23.045C15.0307 23.2067 15.1115 23.4097 15.1115 23.6542C15.1115 23.8989 15.0307 24.102 14.869 24.2635C14.7075 24.4252 14.5044 24.506 14.2598 24.506H11.7375C12.6795 26.0615 13.8866 27.2657 15.3588 28.1187C16.8308 28.9717 18.4362 29.3982 20.175 29.3982C22.013 29.3982 23.6886 28.8992 25.2018 27.9012C26.7148 26.9033 27.8442 25.5749 28.5902 23.9162C28.7149 23.6344 28.8757 23.4115 29.0725 23.2475C29.2695 23.0837 29.5069 23.0327 29.7848 23.0945C30.0461 23.1565 30.2222 23.31 30.313 23.555C30.404 23.7998 30.3872 24.0509 30.2625 24.3082C29.4125 26.3647 28.0788 28.0121 26.2613 29.2502C24.4436 30.4884 22.4148 31.1075 20.175 31.1075C18.1783 31.1075 16.3526 30.6477 14.6978 29.728C13.0431 28.8082 11.6618 27.4976 10.5538 25.7962ZM9.74025 18.9642C9.47892 18.9642 9.281 18.8741 9.1465 18.6937C9.01183 18.5134 8.96717 18.2947 9.0125 18.0375C9.14183 17.2075 9.35667 16.4451 9.657 15.7502C9.95733 15.0556 10.3496 14.3598 10.8338 13.663C10.9791 13.4352 11.1698 13.3004 11.406 13.2587C11.6422 13.2171 11.8536 13.2875 12.0403 13.47C12.2396 13.6733 12.3338 13.8982 12.323 14.1447C12.3123 14.3914 12.2363 14.637 12.095 14.8815C11.7563 15.3917 11.4802 15.9008 11.2667 16.409C11.0534 16.9172 10.8841 17.4703 10.7588 18.0685C10.6928 18.3337 10.5728 18.5492 10.399 18.7152C10.225 18.8812 10.0054 18.9642 9.74025 18.9642ZM19.026 9.73425C19.026 10.0034 18.9389 10.224 18.7648 10.396C18.5904 10.5678 18.3727 10.6867 18.1115 10.7527C17.4927 10.8781 16.924 11.0536 16.4055 11.2792C15.887 11.5051 15.3643 11.7937 14.8375 12.145C14.6057 12.2863 14.3664 12.353 14.1197 12.345C13.8732 12.3372 13.6567 12.2336 13.47 12.0342C13.2962 11.8602 13.2269 11.6562 13.2623 11.422C13.2976 11.1878 13.4208 10.9961 13.632 10.8467C14.3328 10.3461 15.0378 9.94867 15.7468 9.6545C16.4558 9.3605 17.2337 9.1405 18.0805 8.9945C18.3377 8.95317 18.5596 9.00083 18.7463 9.1375C18.9328 9.27417 19.026 9.47308 19.026 9.73425ZM26.518 12.0342C26.3313 12.2414 26.1147 12.3418 25.8682 12.3355C25.6216 12.3292 25.3823 12.2534 25.1505 12.1082C24.6237 11.7607 24.1062 11.4773 23.598 11.258C23.0898 11.0385 22.5283 10.8681 21.9135 10.7467C21.6483 10.6974 21.4328 10.5837 21.2668 10.4055C21.1009 10.2272 21.018 10.0034 21.018 9.73425C21.018 9.47308 21.1081 9.27417 21.2883 9.1375C21.4686 9.00083 21.6873 8.95317 21.9445 8.9945C22.7707 9.13183 23.5363 9.3455 24.2413 9.6355C24.9464 9.92567 25.641 10.3191 26.325 10.8157C26.5402 10.9691 26.6727 11.1638 26.7227 11.4C26.7727 11.6362 26.7045 11.8476 26.518 12.0342ZM30.2538 18.97C29.9886 18.97 29.769 18.8829 29.595 18.7087C29.4212 18.5344 29.3033 18.3147 29.2413 18.0495C29.1159 17.4347 28.9341 16.868 28.6958 16.3495C28.4573 15.831 28.1603 15.3103 27.805 14.7875C27.6637 14.5557 27.5908 14.3216 27.5865 14.0852C27.5822 13.8491 27.6713 13.6293 27.8538 13.426C28.0404 13.2395 28.2477 13.1619 28.4755 13.1932C28.7035 13.2246 28.8901 13.3458 29.0352 13.557C29.5487 14.2538 29.965 14.9557 30.284 15.6627C30.603 16.3697 30.8375 17.153 30.9875 18.0125C31.0328 18.2737 30.9882 18.4986 30.8535 18.6872C30.719 18.8757 30.5191 18.97 30.2538 18.97Z"
                          fill="#F3F6F8"
                        />
                        {'\n'}
                        <defs>
                          {'\n'}
                          <linearGradient
                            id="paint0_linear_9071_5086"
                            x1="19.4792"
                            y1="0"
                            x2="39.2187"
                            y2="0"
                            gradientUnits="userSpaceOnUse"
                          >
                            {'\n'}
                            <stop stopColor="#C8F62E" />
                            {'\n'}
                            <stop offset="0.166667" stopColor="#87FB6B" />
                            {'\n'}
                            <stop offset="0.333333" stopColor="#3FFA9F" />
                            {'\n'}
                            <stop offset="0.5" stopColor="#00F5CC" />
                            {'\n'}
                            <stop offset="0.666667" stopColor="#00ECEC" />
                            {'\n'}
                            <stop offset="0.833333" stopColor="#48E1FE" />
                            {'\n'}
                            <stop offset="1" stopColor="#80D4FF" />
                            {'\n'}
                          </linearGradient>
                          {'\n'}
                        </defs>
                        {'\n'}
                      </svg>
                    </div>
                  </div>
                  <div className="margin-bottom margin-tiny">
                    <h4 className="heading-style-h5">Built on Postgres</h4>
                  </div>
                  <p className="text-body-active text-size-regular">
                    Install the open-source library, connect to Postgres, annotate your workflows and steps. No cluster
                    to provision, no orchestration server.
                  </p>
                </div>
                <div id="w-node-_21703749-384c-1ad0-af87-701ea5c350be-b1c72ac9" className="layout-2col_item">
                  <div className="margin-bottom margin-tiny">
                    <div className="w-embed">
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {'\n'}
                        <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" stroke="url(#paint0_linear_9071_5099)" />
                        {'\n'}
                        <path
                          d="M10.2832 26.0708C10.0719 25.9714 9.93208 25.813 9.86375 25.5955C9.79558 25.3778 9.80908 25.1634 9.90425 24.9523L15.3352 14.2773C15.4346 14.0659 15.5962 13.9313 15.82 13.8733C16.044 13.8154 16.2616 13.8341 16.4727 13.9293C16.6801 14.0286 16.8179 14.187 16.8863 14.4045C16.9544 14.6222 16.9389 14.8346 16.8397 15.0418L11.4147 25.7228C11.3154 25.9341 11.1538 26.0688 10.93 26.1268C10.706 26.1846 10.4904 26.1659 10.2832 26.0708ZM16.8832 26.0708C16.6719 25.9714 16.5321 25.813 16.4637 25.5955C16.3956 25.3778 16.4091 25.1634 16.5043 24.9523L21.9352 14.2773C22.0346 14.0659 22.1962 13.9313 22.42 13.8733C22.644 13.8154 22.8616 13.8341 23.0727 13.9293C23.2801 14.0286 23.4179 14.187 23.4863 14.4045C23.5544 14.6222 23.5389 14.8346 23.4398 15.0418L18.0147 25.7228C17.9154 25.9341 17.7538 26.0688 17.53 26.1268C17.306 26.1846 17.0904 26.1659 16.8832 26.0708ZM23.4833 26.0708C23.2719 25.9714 23.1321 25.813 23.0637 25.5955C22.9956 25.3778 23.0091 25.1634 23.1042 24.9523L28.5352 14.2773C28.6346 14.0659 28.7962 13.9313 29.02 13.8733C29.244 13.8154 29.4616 13.8341 29.6727 13.9293C29.8801 14.0286 30.0179 14.187 30.0863 14.4045C30.1544 14.6222 30.1389 14.8346 30.0398 15.0418L24.6148 25.7228C24.5154 25.9341 24.3538 26.0688 24.13 26.1268C23.906 26.1846 23.6904 26.1659 23.4833 26.0708Z"
                          fill="#F3F6F8"
                        />
                        {'\n'}
                        <defs>
                          {'\n'}
                          <linearGradient
                            id="paint0_linear_9071_5099"
                            x1="19.4792"
                            y1="0"
                            x2="39.2187"
                            y2="0"
                            gradientUnits="userSpaceOnUse"
                          >
                            {'\n'}
                            <stop stopColor="#C8F62E" />
                            {'\n'}
                            <stop offset="0.166667" stopColor="#87FB6B" />
                            {'\n'}
                            <stop offset="0.333333" stopColor="#3FFA9F" />
                            {'\n'}
                            <stop offset="0.5" stopColor="#00F5CC" />
                            {'\n'}
                            <stop offset="0.666667" stopColor="#00ECEC" />
                            {'\n'}
                            <stop offset="0.833333" stopColor="#48E1FE" />
                            {'\n'}
                            <stop offset="1" stopColor="#80D4FF" />
                            {'\n'}
                          </linearGradient>
                          {'\n'}
                        </defs>
                        {'\n'}
                      </svg>
                    </div>
                  </div>
                  <div className="margin-bottom margin-tiny">
                    <h4 className="heading-style-h5">Durable queues</h4>
                  </div>
                  <p className="text-body-active text-size-regular">
                    Control concurrency globally, per-worker, or per-tenant. Temporal has no comparable queueing
                    abstractions.
                  </p>
                </div>
                <div id="w-node-_21703749-384c-1ad0-af87-701ea5c350c6-b1c72ac9" className="layout-2col_item">
                  <div className="margin-bottom margin-tiny">
                    <div className="w-embed">
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {'\n'}
                        <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" stroke="url(#paint0_linear_9071_5103)" />
                        {'\n'}
                        <path
                          d="M14.6288 29.3722C14.4546 29.1979 14.3675 28.9978 14.3675 28.772C14.3675 28.5462 14.4544 28.3462 14.6283 28.1722L19.7065 23.1C20.0337 22.7602 20.4357 22.5934 20.9125 22.5997C21.3893 22.6061 21.7913 22.7728 22.1185 23.1L24.4 25.3815L29.2033 20.6032C29.3746 20.4332 29.5738 20.3492 29.801 20.3512C30.0282 20.3532 30.2268 20.4379 30.3968 20.6052C30.5668 20.7726 30.6518 20.9714 30.6518 21.2017C30.6518 21.4322 30.5668 21.6326 30.3968 21.8027L25.5935 26.6C25.2655 26.9272 24.8665 27.0907 24.3965 27.0907C23.9263 27.0907 23.5277 26.9272 23.2005 26.6L20.9 24.2995L15.8218 29.3777C15.6478 29.5476 15.4478 29.6315 15.222 29.6295C14.9962 29.6277 14.7984 29.5419 14.6288 29.3722ZM11.5538 29.1495C11.0941 29.1495 10.6953 28.9806 10.3573 28.6427C10.0194 28.3051 9.8505 27.9062 9.8505 27.4462V12.0537C9.8505 11.5921 10.0194 11.1918 10.3573 10.853C10.6949 10.514 11.0938 10.3445 11.5538 10.3445H26.4463C26.9079 10.3445 27.3082 10.514 27.647 10.853C27.986 11.1918 28.1555 11.5921 28.1555 12.0537V16.9342C28.1555 17.1746 28.0725 17.3766 27.9065 17.5402C27.7407 17.7039 27.5378 17.7857 27.2978 17.7857H11.5538V29.1495ZM11.5538 16.1245H26.4463V12.0537H11.5538V16.1245Z"
                          fill="#F3F6F8"
                        />
                        {'\n'}
                        <defs>
                          {'\n'}
                          <linearGradient
                            id="paint0_linear_9071_5103"
                            x1="19.4792"
                            y1="0"
                            x2="39.2187"
                            y2="0"
                            gradientUnits="userSpaceOnUse"
                          >
                            {'\n'}
                            <stop stopColor="#C8F62E" />
                            {'\n'}
                            <stop offset="0.166667" stopColor="#87FB6B" />
                            {'\n'}
                            <stop offset="0.333333" stopColor="#3FFA9F" />
                            {'\n'}
                            <stop offset="0.5" stopColor="#00F5CC" />
                            {'\n'}
                            <stop offset="0.666667" stopColor="#00ECEC" />
                            {'\n'}
                            <stop offset="0.833333" stopColor="#48E1FE" />
                            {'\n'}
                            <stop offset="1" stopColor="#80D4FF" />
                            {'\n'}
                          </linearGradient>
                          {'\n'}
                        </defs>
                        {'\n'}
                      </svg>
                    </div>
                  </div>
                  <div className="margin-bottom margin-tiny">
                    <h4 className="heading-style-h5">Sub-2ms step latency</h4>
                  </div>
                  <p className="text-body-active text-size-regular">
                    Each step checkpoint is a single Postgres write. Temporal's async dispatch model adds tens to
                    hundreds of milliseconds per step.
                    <br />
                  </p>
                </div>
                <div id="w-node-_21703749-384c-1ad0-af87-701ea5c350cf-b1c72ac9" className="layout-2col_item">
                  <div className="margin-bottom margin-tiny">
                    <div className="w-embed">
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {'\n'}
                        <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" stroke="url(#paint0_linear_9071_5111)" />
                        {'\n'}
                        <path
                          d="M19.5838 19.9955C19.5838 19.754 19.6656 19.5524 19.8293 19.3908C19.9929 19.2291 20.1949 19.1482 20.4353 19.1482L26.9108 19.1483L22.3973 14.6408C22.2234 14.4669 22.1365 14.266 22.1365 14.038C22.1365 13.8102 22.2234 13.6133 22.3973 13.4473C22.5673 13.2734 22.7652 13.1865 22.991 13.1865C23.217 13.1865 23.4169 13.2734 23.5908 13.4473L29.5468 19.4033C29.6381 19.4946 29.7034 19.59 29.7428 19.6895C29.7821 19.789 29.8018 19.8936 29.8018 20.0033C29.8018 20.1131 29.7821 20.2176 29.7428 20.3168C29.7034 20.4161 29.6381 20.5114 29.5468 20.6027L23.5908 26.5587C23.4169 26.7286 23.2157 26.8145 22.987 26.8165C22.7585 26.8185 22.5606 26.7358 22.3933 26.5685C22.2221 26.392 22.1365 26.189 22.1365 25.9595C22.1365 25.7298 22.2234 25.5317 22.3973 25.3652L26.9108 20.8518L20.4353 20.8517C20.1949 20.8517 19.9929 20.7694 19.8293 20.6047C19.6656 20.4402 19.5838 20.2372 19.5838 19.9955ZM14.5538 19.9955C14.5538 19.754 14.6356 19.5524 14.7993 19.3907C14.9629 19.2291 15.165 19.1482 15.4055 19.1482L17.226 19.1482C17.4665 19.1482 17.6696 19.2306 17.8353 19.3952C18.0009 19.5597 18.0838 19.7628 18.0838 20.0045C18.0838 20.246 18.0009 20.4476 17.8353 20.6092C17.6696 20.7709 17.4665 20.8517 17.226 20.8517L15.4055 20.8517C15.165 20.8517 14.9629 20.7694 14.7993 20.6047C14.6356 20.4402 14.5538 20.2372 14.5538 19.9955ZM9.85051 19.9955C9.85051 19.754 9.93234 19.5524 10.096 19.3907C10.2597 19.2291 10.4618 19.1482 10.7023 19.1482L12.2023 19.1482C12.4426 19.1482 12.6446 19.2306 12.8083 19.3952C12.9719 19.5597 13.0538 19.7628 13.0538 20.0045C13.0538 20.246 12.9719 20.4476 12.8083 20.6092C12.6446 20.7709 12.4426 20.8517 12.2023 20.8517L10.7023 20.8517C10.4618 20.8517 10.2597 20.7694 10.096 20.6047C9.93234 20.4402 9.85051 20.2372 9.85051 19.9955Z"
                          fill="#F3F6F8"
                        />
                        {'\n'}
                        <defs>
                          {'\n'}
                          <linearGradient
                            id="paint0_linear_9071_5111"
                            x1="19.4792"
                            y1="0"
                            x2="39.2187"
                            y2="0"
                            gradientUnits="userSpaceOnUse"
                          >
                            {'\n'}
                            <stop stopColor="#C8F62E" />
                            {'\n'}
                            <stop offset="0.166667" stopColor="#87FB6B" />
                            {'\n'}
                            <stop offset="0.333333" stopColor="#3FFA9F" />
                            {'\n'}
                            <stop offset="0.5" stopColor="#00F5CC" />
                            {'\n'}
                            <stop offset="0.666667" stopColor="#00ECEC" />
                            {'\n'}
                            <stop offset="0.833333" stopColor="#48E1FE" />
                            {'\n'}
                            <stop offset="1" stopColor="#80D4FF" />
                            {'\n'}
                          </linearGradient>
                          {'\n'}
                        </defs>
                        {'\n'}
                      </svg>
                    </div>
                  </div>
                  <div className="margin-bottom margin-tiny">
                    <h4 className="heading-style-h5">Your data stays yours</h4>
                  </div>
                  <p className="text-body-active text-size-regular">
                    Workflow checkpoints live in your Postgres. Nothing is sent to an external server. No sensitive data
                    ever leaves your infrastructure.
                  </p>
                </div>
                <div id="w-node-_21703749-384c-1ad0-af87-701ea5c350d7-b1c72ac9" className="layout-2col_item">
                  <div className="margin-bottom margin-tiny">
                    <div className="w-embed">
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {'\n'}
                        <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" stroke="url(#paint0_linear_9071_5107)" />
                        {'\n'}
                        <path
                          d="M20.0027 29.1495C17.4404 29.1495 15.2745 28.748 13.505 27.945C11.7353 27.1422 10.8505 26.1605 10.8505 25V15C10.8505 13.8573 11.7437 12.8791 13.53 12.0652C15.3162 11.2514 17.4724 10.8445 19.9987 10.8445C22.5211 10.8445 24.6777 11.2514 26.4687 12.0652C28.2599 12.8791 29.1555 13.8573 29.1555 15V25C29.1555 26.1605 28.2696 27.1422 26.4977 27.945C24.7261 28.748 22.5611 29.1495 20.0027 29.1495ZM20 16.794C21.4307 16.794 22.8968 16.5742 24.3985 16.1345C25.9002 15.6948 26.8737 15.2 27.319 14.65C26.857 14.1167 25.8728 13.626 24.3665 13.178C22.8602 12.73 21.4037 12.506 19.997 12.506C18.5403 12.506 17.0713 12.7227 15.59 13.156C14.1087 13.5893 13.1327 14.0873 12.662 14.65C13.1327 15.2333 14.099 15.7365 15.561 16.1595C17.023 16.5825 18.5027 16.794 20 16.794ZM19.975 22.138C20.671 22.138 21.3662 22.0995 22.0607 22.0225C22.7554 21.9455 23.4219 21.831 24.0602 21.679C24.6986 21.527 25.3108 21.3407 25.897 21.12C26.483 20.8995 27.0153 20.6539 27.494 20.3832V16.7055C27.0027 16.9722 26.4643 17.2138 25.879 17.4305C25.2937 17.6472 24.678 17.8295 24.032 17.9775C23.386 18.1255 22.7233 18.2402 22.044 18.3215C21.3647 18.4028 20.6742 18.4435 19.9727 18.4435C19.2794 18.4435 18.585 18.4028 17.8895 18.3215C17.1942 18.2402 16.5261 18.1245 15.8852 17.9745C15.2444 17.8245 14.6355 17.6422 14.0585 17.4275C13.4815 17.2128 12.966 16.9722 12.512 16.7055V20.3832C12.962 20.6539 13.4723 20.8985 14.043 21.117C14.6137 21.3357 15.2198 21.522 15.8615 21.676C16.5032 21.83 17.1722 21.9455 17.8687 22.0225C18.5654 22.0995 19.2675 22.138 19.975 22.138ZM20 27.488C20.792 27.492 21.609 27.4242 22.451 27.2845C23.2932 27.1448 24.0684 26.9593 24.7767 26.728C25.4851 26.4967 26.087 26.2383 26.5825 25.953C27.0782 25.6677 27.382 25.375 27.494 25.075V22.0815C27.0193 22.3522 26.4913 22.5937 25.91 22.806C25.3287 23.0183 24.7168 23.1995 24.0745 23.3495C23.432 23.4995 22.7665 23.612 22.078 23.687C21.3895 23.762 20.6885 23.7995 19.975 23.7995C19.2635 23.7995 18.5595 23.761 17.863 23.684C17.1663 23.607 16.4982 23.4935 15.8585 23.3435C15.2188 23.1935 14.6147 23.0123 14.046 22.8C13.4773 22.5877 12.966 22.3482 12.512 22.0815V25.0997C12.6073 25.3832 12.8986 25.6698 13.3857 25.9595C13.8731 26.2492 14.4741 26.5065 15.1887 26.7315C15.9034 26.9565 16.6818 27.1388 17.524 27.2785C18.366 27.4182 19.1913 27.488 20 27.488Z"
                          fill="#F3F6F8"
                        />
                        {'\n'}
                        <defs>
                          {'\n'}
                          <linearGradient
                            id="paint0_linear_9071_5107"
                            x1="19.4792"
                            y1="0"
                            x2="39.2187"
                            y2="0"
                            gradientUnits="userSpaceOnUse"
                          >
                            {'\n'}
                            <stop stopColor="#C8F62E" />
                            {'\n'}
                            <stop offset="0.166667" stopColor="#87FB6B" />
                            {'\n'}
                            <stop offset="0.333333" stopColor="#3FFA9F" />
                            {'\n'}
                            <stop offset="0.5" stopColor="#00F5CC" />
                            {'\n'}
                            <stop offset="0.666667" stopColor="#00ECEC" />
                            {'\n'}
                            <stop offset="0.833333" stopColor="#48E1FE" />
                            {'\n'}
                            <stop offset="1" stopColor="#80D4FF" />
                            {'\n'}
                          </linearGradient>
                          {'\n'}
                        </defs>
                        {'\n'}
                      </svg>
                    </div>
                  </div>
                  <div className="margin-bottom margin-tiny">
                    <h4 className="heading-style-h5">SQL-powered introspection</h4>
                  </div>
                  <p className="text-body-active text-size-regular">
                    Search, pause, cancel, or resume workflows using SQL. Fork any workflow from any step,
                    programmatically or from the web UI.
                    <br />
                  </p>
                </div>
                <div id="w-node-_21703749-384c-1ad0-af87-701ea5c350e0-b1c72ac9" className="layout-2col_item">
                  <div className="margin-bottom margin-tiny">
                    <div className="w-embed">
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {'\n'}
                        <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" stroke="url(#paint0_linear_9071_5115)" />
                        {'\n'}
                        <path
                          d="M14.3768 29.293C13.9639 29.293 13.5985 29.1589 13.2805 28.8907C12.9627 28.6224 12.7686 28.282 12.6983 27.8695L11.0663 18.1082C11.0249 17.8429 11.086 17.6108 11.2495 17.412C11.4128 17.213 11.6273 17.1135 11.893 17.1135H28.107C28.3727 17.1135 28.5872 17.213 28.7505 17.412C28.914 17.6108 28.9751 17.8429 28.9338 18.1082L27.3018 27.8695C27.2314 28.282 27.0373 28.6224 26.7195 28.8907C26.4015 29.1589 26.0381 29.293 25.6293 29.293H14.3768ZM12.9625 18.8167L14.3518 27.5837H25.6543L27.0435 18.8167H12.9625ZM18 22.8467H22C22.2403 22.8467 22.4423 22.7617 22.606 22.5917C22.7698 22.4219 22.8518 22.2169 22.8518 21.9767C22.8518 21.7404 22.7698 21.5415 22.606 21.38C22.4423 21.2183 22.2403 21.1375 22 21.1375H18C17.7722 21.1375 17.5733 21.2193 17.4033 21.383C17.2333 21.5467 17.1483 21.7487 17.1483 21.9892C17.1483 22.2211 17.2333 22.4219 17.4033 22.5917C17.5733 22.7617 17.7722 22.8467 18 22.8467ZM14 15.6135C13.7722 15.6135 13.5733 15.5296 13.4033 15.3617C13.2333 15.1937 13.1483 14.9897 13.1483 14.7495C13.1483 14.5132 13.2333 14.3142 13.4033 14.1527C13.5733 13.9911 13.7722 13.9102 14 13.9102H26C26.2403 13.9102 26.4423 13.9921 26.606 14.1557C26.7698 14.3194 26.8518 14.5215 26.8518 14.762C26.8518 14.9938 26.7698 15.1937 26.606 15.3617C26.4423 15.5296 26.2403 15.6135 26 15.6135H14ZM16 12.4102C15.7722 12.4102 15.5733 12.3253 15.4033 12.1555C15.2333 11.9855 15.1483 11.7824 15.1483 11.5462C15.1483 11.3099 15.2333 11.11 15.4033 10.9465C15.5733 10.7828 15.7722 10.701 16 10.701H24C24.2403 10.701 24.4423 10.7838 24.606 10.9495C24.7698 11.1152 24.8518 11.3182 24.8518 11.5587C24.8518 11.7866 24.7698 11.9855 24.606 12.1555C24.4423 12.3253 24.2403 12.4102 24 12.4102H16Z"
                          fill="#F3F6F8"
                        />
                        {'\n'}
                        <defs>
                          {'\n'}
                          <linearGradient
                            id="paint0_linear_9071_5115"
                            x1="19.4792"
                            y1="0"
                            x2="39.2187"
                            y2="0"
                            gradientUnits="userSpaceOnUse"
                          >
                            {'\n'}
                            <stop stopColor="#C8F62E" />
                            {'\n'}
                            <stop offset="0.166667" stopColor="#87FB6B" />
                            {'\n'}
                            <stop offset="0.333333" stopColor="#3FFA9F" />
                            {'\n'}
                            <stop offset="0.5" stopColor="#00F5CC" />
                            {'\n'}
                            <stop offset="0.666667" stopColor="#00ECEC" />
                            {'\n'}
                            <stop offset="0.833333" stopColor="#48E1FE" />
                            {'\n'}
                            <stop offset="1" stopColor="#80D4FF" />
                            {'\n'}
                          </linearGradient>
                          {'\n'}
                        </defs>
                        {'\n'}
                      </svg>
                    </div>
                  </div>
                  <div className="margin-bottom margin-tiny">
                    <h4 className="heading-style-h5">Single point-of-failure</h4>
                  </div>
                  <p className="text-body-active text-size-regular">
                    DBOS only depends on Postgres. Temporal adds two: the Temporal server and its Cassandra data store
                    each a new operational risk.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_layout-features">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large">
              <div className="layout-2col_component is-testimonials">
                <div className="margin-bottom margin-small">
                  <div className="max-width-medium">
                    <div className="text-align-center">
                      <div className="margin-bottom margin-xsmall">
                        <div className="tagline-container_glow">
                          <h2 className="text-size-small tagline-container is-glow">How it works</h2>
                        </div>
                      </div>
                      <div className="margin-bottom margin-small is-partner">
                        <h2 className="heading-style-h2">Durable in minutes. Not weeks.</h2>
                      </div>
                      <div className="margin-bottom margin-small">
                        <p className="text-body-active">
                          {
                            'Take DBOS to prod with simple annotations on the functions that already exist in your codebase. With Temporal, you move your code into workers, configure a server, and require a rewrite on your app &\u00a0workflows.'
                          }
                        </p>
                      </div>
                      <div data-wf--button--variant="primary-large" className="button-wrapper">
                        <a
                          href="https://docs.dbos.dev/explanations/migrating-from-temporal"
                          className="button w-inline-block"
                        >
                          <div className="text-block-4">See our migration guide</div>
                          <div className="icon-chevron-right w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="layout-compare_container">
                  <div className="layout-compare_table">
                    <div className="layout-compare_th">
                      <h3 className="heading-style-h5">DBOS</h3>
                      <div className="tagline-container is-new is-glow">~20 minutes</div>
                    </div>
                    <div className="layout-compare_th">
                      <h3 className="heading-style-h5">Temporal</h3>
                      <div className="tagline-container">~2 weeks</div>
                    </div>
                    <div className="layout-compare_cell">
                      <p className="text-body-active">1. Install the open-source library</p>
                    </div>
                    <div className="layout-compare_cell">
                      <p className="text-body-active">1. Provision and operate a Temporal server</p>
                    </div>
                    <div className="layout-compare_cell">
                      <p className="text-body-active">2. Connect to your existing Postgres</p>
                    </div>
                    <div className="layout-compare_cell">
                      <p className="text-body-active">2. Set up Cassandra as the backing data store</p>
                    </div>
                    <div className="layout-compare_cell">
                      <p className="text-body-active">
                        {'3. Add '}
                        <span className="text-style-code">@DBOS.workflow()</span>
                        {' and '}
                        <span className="text-style-code">@DBOS.step()</span>
                        {' decorators'}
                      </p>
                    </div>
                    <div className="layout-compare_cell">
                      <p className="text-body-active">3. Build and scale a cluster of Temporal workers</p>
                    </div>
                    <div className="layout-compare_cell">
                      <p className="text-body-active">4. Deploy your application exactly as before</p>
                    </div>
                    <div className="layout-compare_cell">
                      <p className="text-body-active">{'4. Rewrite app & workflow interactions via Temporal API'}</p>
                    </div>
                    <div className="layout-code_code-block is-compare">
                      <div className="code_card-file-bar is-compare">
                        <div className="code_card-bubble-wrapper">
                          <div className="code_card-bubble" />
                          <div className="code_card-bubble" />
                          <div className="code_card-bubble" />
                        </div>
                        <div className="text-size-tiny text-color-body">dbos-build.py</div>
                      </div>
                      <div
                        data-code-source="true"
                        fs-codehighlight-theme="fs-codehighlight-theme"
                        fs-codehighlight-element="code"
                        className="layout-compare_code w-embed"
                      >
                        <pre>
                          <HighlightedCode
                            className="language-python"
                            code={
                              '\n# Annotate what you already have\n@DBOS.step()\ndef validate_payment(): ...\n\n\n@DBOS.step()\ndef ship_order(): ...\n\n\n@DBOS.workflow()\ndef checkout_workflow():\n    validate_payment()\n    check_inventory()\n    ship_order()\n    notify_customer()\n'
                            }
                          />
                          {'\n'}
                        </pre>
                      </div>
                    </div>
                    <div className="layout-code_code-block is-compare">
                      <div className="code_card-file-bar is-compare">
                        <div className="code_card-bubble-wrapper">
                          <div className="code_card-bubble" />
                          <div className="code_card-bubble" />
                          <div className="code_card-bubble" />
                        </div>
                        <div className="text-size-tiny text-color-body">temporal-build.py</div>
                      </div>
                      <div
                        data-code-source="true"
                        fs-codehighlight-theme="fs-codehighlight-theme"
                        fs-codehighlight-element="code"
                        className="layout-compare_code w-embed"
                      >
                        <pre>
                          <HighlightedCode
                            className="language-python"
                            code={
                              '\nimport asyncio\nfrom datetime import timedelta\nfrom temporalio import activity, workflow\nfrom temporalio.client import Client\nfrom temporalio.worker import Worker\n\n# 1. Define Activities (Equivalent to DBOS Steps)\n@activity.defn\nasync def validate_payment() -> str:\n    pass\n\n@activity.defn\nasync def check_inventory() -> str:\n    pass\n\n@activity.defn\nasync def ship_order() -> str:\n    pass\n\n@activity.defn\nasync def notify_customer() -> str:\n    pass\n\n# 2. Define the Workflow\n# Temporal requires workflows to be defined as classes with a run method\n@workflow.defn\nclass CheckoutWorkflow:\n    @workflow.run\n    async def run(self) -> None:\n        # Activities must be explicitly awaited and require timeout configurations\n        await workflow.execute_activity(\n            validate_payment,\n            start_to_close_timeout=timedelta(seconds=10),\n        )\n        await workflow.execute_activity(\n            check_inventory,\n            start_to_close_timeout=timedelta(seconds=10),\n        )\n        await workflow.execute_activity(\n            ship_order,\n            start_to_close_timeout=timedelta(seconds=10),\n        )\n        await workflow.execute_activity(\n            notify_customer,\n            start_to_close_timeout=timedelta(seconds=10),\n        )\n\n# 3. Setup the Client and Worker\n# This is the boilerplate required to connect your code to the Temporal Server, \n# which in turn talks to the Cassandra/Postgres datastore.\nasync def main():\n    # Connect to the Temporal server (assuming it is running locally or via Cloud)\n    client = await Client.connect("localhost:7233")\n\n    # Initialize and run the worker to host the workflow and activities\n    worker = Worker(\n        client,\n        task_queue="checkout-task-queue",\n        workflows=[CheckoutWorkflow],\n        activities=[validate_payment, check_inventory, ship_order, notify_customer],\n    )\n    \n    print("Worker starting. Listening to Temporal Server...")\n    await worker.run()\n\nif __name__ == "__main__":\n    asyncio.run(main())\n'
                            }
                          />
                          {'\n'}
                        </pre>
                      </div>
                      <div className="code_card-gradient" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_console">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-medium">
              <div className="margin-bottom margin-medium">
                <div className="text-align-center">
                  <div className="margin-bottom margin-xsmall">
                    <div className="tagline-container_glow">
                      <h2 className="text-size-small tagline-container is-glow">
                        DBOS vs. Temporal Feature Comparison
                      </h2>
                    </div>
                  </div>
                  <div className="margin-bottom margin-small is-partner">
                    <h3 className="heading-style-h2">Feature by Feature</h3>
                  </div>
                </div>
              </div>
              <div className="layout-compare_gradient" />
              <div className="layout-compare_container">
                <div className="layout-compare_table is-all-features">
                  <div className="layout-compare_th">
                    <h4 className="text-size-medium text-weight-medium">Feature</h4>
                  </div>
                  <div className="layout-compare_th">
                    <h4 className="text-size-medium text-weight-medium">DBOS</h4>
                    <img
                      src="/assets/images/6a26360187ef45c67848e117_dbos-logo.avif"
                      loading="lazy"
                      alt=""
                      className="compare_logo is-small"
                    />
                  </div>
                  <div className="layout-compare_th">
                    <h4 className="text-size-medium text-weight-medium">Temporal</h4>
                    <img
                      src="/assets/images/6a263622d597c8e67985c02d_temporal-logo.avif"
                      loading="lazy"
                      alt=""
                      className="compare_logo is-small"
                    />
                  </div>
                  <div className="layout-compare_cell is-feature">
                    <p className="text-body-active text-color-heading">License</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">MIT</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">MIT / Apache 2.0</p>
                  </div>
                  <div className="layout-compare_cell is-feature">
                    <p className="text-body-active text-color-heading">Architecture</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">LIbrary (no server)</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">External orchestration service</p>
                  </div>
                  <div className="layout-compare_cell is-feature">
                    <p className="text-body-active text-color-heading">Step latency</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">1 to 2 ms (Postgre write)</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">Tens to hundreds of ms</p>
                  </div>
                  <div className="layout-compare_cell is-feature">
                    <p className="text-body-active text-color-heading">Infrastructure required</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">Postgres only</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">{'Temporal server &\u00a0Cassandra'}</p>
                  </div>
                  <div className="layout-compare_cell is-feature">
                    <p className="text-body-active text-color-heading">New points of failure</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">None (only Postgres)</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">{'2+\u00a0(Temporal server, Cassandra)'}</p>
                  </div>
                  <div className="layout-compare_cell is-feature">
                    <p className="text-body-active text-color-heading">Adoption effort</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">Install library, annotate code</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">Full application rearchitecting</p>
                  </div>
                  <div className="layout-compare_cell is-feature">
                    <p className="text-body-active text-color-heading">Workflow introspection</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">{'SQL\u00a0queries +\u00a0Web UI'}</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">{'Temporal UI\u00a0+\u00a0custom queries'}</p>
                  </div>
                  <div className="layout-compare_cell is-feature">
                    <p className="text-body-active text-color-heading">Fork / restart from step</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">Yes, first-class feature</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">Not available</p>
                  </div>
                  <div className="layout-compare_cell is-feature">
                    <p className="text-body-active text-color-heading">Data privacy</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">Your Postgres, your data</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">Via Temporal server</p>
                  </div>
                  <div className="layout-compare_cell is-feature">
                    <p className="text-body-active text-color-heading">Durable queues</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">Built-in with flow control</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">Built-in with flow control</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_console">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large">
              <div className="margin-bottom margin-medium">
                <div className="max-width-medium">
                  <div className="text-align-center">
                    <div className="margin-bottom margin-xsmall">
                      <h2 className="tagline-container text-size-small">Cost Comparison</h2>
                    </div>
                    <div className="margin-bottom margin-small is-partner">
                      <h3 className="heading-style-h2">{'Is DBOS\u00a0less costly than Temporal?'}</h3>
                    </div>
                    <div className="margin-bottom margin-small">
                      <p className="text-body-active">
                        Running DBOS is often 2-10x less expensive than running Temporal.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="layout-compare_gradient" />
              <div className="layout-compare_container">
                <div className="layout-compare_table is-cost-compare">
                  <div className="layout-compare_th">
                    <h4 className="text-size-medium text-weight-medium">Cost</h4>
                  </div>
                  <div className="layout-compare_th">
                    <h4 className="text-size-medium text-weight-medium">DBOS</h4>
                    <img
                      src="/assets/images/6a26360187ef45c67848e117_dbos-logo.avif"
                      loading="lazy"
                      alt=""
                      className="compare_logo is-small"
                    />
                  </div>
                  <div className="layout-compare_th">
                    <h4 className="text-size-medium text-weight-medium">Temporal</h4>
                    <img
                      src="/assets/images/6a263622d597c8e67985c02d_temporal-logo.avif"
                      loading="lazy"
                      alt=""
                      className="compare_logo is-small"
                    />
                  </div>
                  <div className="layout-compare_cell is-feature">
                    <p className="text-body-active text-color-heading">Incremental infrastructure costs?</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">$0</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">$$$, to host and run Temporal and Cassandra clusters.</p>
                  </div>
                  <div className="layout-compare_cell is-feature">
                    <p className="text-body-active text-color-heading">Incremental people costs</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">$0</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">
                      $$$ - 2 to 10 full time employees required to operate Temporal cluster (source: Temporal)
                    </p>
                  </div>
                  <div className="layout-compare_cell is-feature">
                    <p className="text-body-active text-color-heading">
                      Workflow concurrency, capacity, throughput, scheduling, and storage limits.
                    </p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">$0 or none</p>
                  </div>
                  <div className="layout-compare_cell">
                    <p className="text-body-active">Yes (Temporal Cloud). Extra cost to increase.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_console">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large">
              <div className="layout16_component">
                <div className="w-layout-grid layout16_content is-compare">
                  <div className="layout16_content-left">
                    <div className="margin-bottom margin-small">
                      <div className="tagline-container">
                        <div className="text-style-tagline">{'Is DBOS\u00a0a Temporal alternative?'}</div>
                      </div>
                    </div>
                    <div className="margin-bottom margin-small">
                      <h2 className="heading-style-h2">DBOS as a Temporal Alternative</h2>
                    </div>
                    <div className="margin-bottom margin-small">
                      <h3 className="heading-style-h4">What you need to know</h3>
                    </div>
                    <div className="margin-bottom margin-small">
                      <p className="text-body-active">
                        {'DBOS is a popular alternative to Temporal. '}
                        <a href="/customer-stories">Customers like Yutori, Roche, Notion, and others</a>
                        {' have chosen DBOS over Temporal.'}
                        <br />
                        <br />
                        {
                          'DBOS is based on years of R&D at Stanford and MIT, led by the creator of Postgres, Mike Stonebraker and Databricks CTO and co-founder, Matei Zaharia. The big idea behind DBOS is to embed durability into your code via a library, rather than having to run a heavyweight workflow orchestration server external to your application as with Temporal.'
                        }
                        <br />
                        <br />
                        {
                          'The bottom line: Temporal requires extra infrastructure and a rearchitecture of\u00a0your application. DBOS requires minimal coding changes and no external orchestration server to operate, making it simpler and much less costly than Temporal.'
                        }
                      </p>
                    </div>
                  </div>
                  <div className="layout16_image">
                    <img
                      src="/assets/images/6a014c75eb4ed62a4f39bd07_dbos-workflow.png"
                      loading="lazy"
                      sizes="100vw"
                      srcSet="/assets/images/6a014c75eb4ed62a4f39bd07_dbos-workflow-p-500.png 500w, /assets/images/6a014c75eb4ed62a4f39bd07_dbos-workflow-p-800.png 800w, /assets/images/6a014c75eb4ed62a4f39bd07_dbos-workflow-p-1080.png 1080w, /assets/images/6a014c75eb4ed62a4f39bd07_dbos-workflow-p-1600.png 1600w, /assets/images/6a014c75eb4ed62a4f39bd07_dbos-workflow-p-2000.png 2000w, /assets/images/6a014c75eb4ed62a4f39bd07_dbos-workflow-p-2600.png 2600w, /assets/images/6a014c75eb4ed62a4f39bd07_dbos-workflow.png 2880w"
                      alt=""
                      className="image-21"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_related-cases">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-medium">
              <div className="margin-bottom margin-medium">
                <div className="text-align-center">
                  <div className="margin-bottom margin-xsmall">
                    <div className="tagline-container_glow">
                      <h2 className="text-size-small tagline-container is-glow">Customer Stories</h2>
                    </div>
                  </div>
                  <div className="margin-bottom margin-small is-partner">
                    <h3 className="heading-style-h2">More make the switch</h3>
                  </div>
                </div>
              </div>
              <div className="margin-bottom margin-medium">
                <div
                  fs-list-filteringclass="is-list-filtering"
                  className="partnerships_featured-list-wrapper w-dyn-list"
                >
                  <div role="list" className="partnerships_featured-list is-compare w-dyn-items">
                    <div role="listitem" className="partnerships_featured-item w-dyn-item">
                      <div className="partnerships_header is-customer-stories">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/69fbc7c2a7a32f5a876ea82b_Ontologize.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p className="tagline-container text-size-small">Software</p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Ontologize</h3>
                        </div>
                        <p className="text-body-active">
                          DBOS workflows deploy thousands of isolated Palantir software stacks per day to Palantir
                          trainees.
                        </p>
                      </div>
                      <div
                        data-wf--button--variant="tertiary-large"
                        className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                      >
                        <a
                          href="/case-studies/ontologize"
                          className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                        >
                          <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                            Read case study
                          </div>
                          <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div role="listitem" className="partnerships_featured-item w-dyn-item">
                      <div className="partnerships_header is-customer-stories">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/6a0de1aaed314508a8b6d934_FlowGen_Labs-Icon-DBOS.png"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p className="tagline-container text-size-small">AI - Agentic ERP Ops</p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">FlowGen Labs</h3>
                        </div>
                        <p className="text-body-active">
                          FlowGen Labs selected DBOS over Temporal to make long-lived workflows durable and observable
                          within the rigid security constraints of customer environments, including air-gapped
                          deployments.
                        </p>
                      </div>
                      <div
                        data-wf--button--variant="tertiary-large"
                        className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                      >
                        <a
                          href="/case-studies/flowgen-labs"
                          className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                        >
                          <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                            Read case study
                          </div>
                          <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_faq">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-small">
              <div className="faq_component">
                <div className="max-width-medium">
                  <div className="margin-bottom margin-medium">
                    <div className="text-align-center">
                      <div className="margin-bottom margin-xsmall">
                        <div className="tagline-container">
                          <h2 className="text-style-tagline">FAQs</h2>
                        </div>
                      </div>
                      <h3 className="heading-style-h2">Quick answers</h3>
                    </div>
                  </div>
                </div>
                <div className="max-width-large">
                  <div className="w-layout-grid faq_list">
                    <FaqAccordion className="faq_accordion">
                      <FaqQuestion className="faq_question">
                        <h5 className="text-size-medium text-align-left">
                          Is DBOS a drop-in replacement for Temporal?
                        </h5>
                        <FaqIcon className="faq_icon-wrappper">
                          <div className="icon-embed-small-3 w-embed">
                            <svg
                              width="100%"
                              height="100%"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M25.3333 15.667V16.3336C25.3333 16.7018 25.0349 17.0003 24.6667 17.0003H17V24.667C17 25.0351 16.7015 25.3336 16.3333 25.3336H15.6667C15.2985 25.3336 15 25.0351 15 24.667V17.0003H7.3333C6.96511 17.0003 6.66663 16.7018 6.66663 16.3336V15.667C6.66663 15.2988 6.96511 15.0003 7.3333 15.0003H15V7.33365C15 6.96546 15.2985 6.66699 15.6667 6.66699H16.3333C16.7015 6.66699 17 6.96546 17 7.33365V15.0003H24.6667C25.0349 15.0003 25.3333 15.2988 25.3333 15.667Z"
                                fill="currentColor"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </FaqIcon>
                      </FaqQuestion>
                      <FaqAnswer className="faq_answer">
                        <div className="margin-bottom margin-small">
                          <p className="text-body-active text-size-regular">
                            DBOS covers the same core use case — durable, fault-tolerant workflows — but with a
                            fundamentally different architecture. The programming model is similar (annotate workflows
                            and steps), but migrating requires updating annotations and removing Temporal-specific SDK
                            calls. See the migration guide at docs.dbos.dev for a step-by-step walkthrough.
                            <br />
                          </p>
                        </div>
                      </FaqAnswer>
                    </FaqAccordion>
                    <FaqAccordion className="faq_accordion">
                      <FaqQuestion className="faq_question">
                        <h5 className="text-size-medium text-align-left">
                          Do I need to change how my application is deployed?
                        </h5>
                        <FaqIcon className="faq_icon-wrappper">
                          <div className="icon-embed-small-3 w-embed">
                            <svg
                              width="100%"
                              height="100%"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M25.3333 15.667V16.3336C25.3333 16.7018 25.0349 17.0003 24.6667 17.0003H17V24.667C17 25.0351 16.7015 25.3336 16.3333 25.3336H15.6667C15.2985 25.3336 15 25.0351 15 24.667V17.0003H7.3333C6.96511 17.0003 6.66663 16.7018 6.66663 16.3336V15.667C6.66663 15.2988 6.96511 15.0003 7.3333 15.0003H15V7.33365C15 6.96546 15.2985 6.66699 15.6667 6.66699H16.3333C16.7015 6.66699 17 6.96546 17 7.33365V15.0003H24.6667C25.0349 15.0003 25.3333 15.2988 25.3333 15.667Z"
                                fill="currentColor"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </FaqIcon>
                      </FaqQuestion>
                      <FaqAnswer className="faq_answer">
                        <div className="margin-bottom margin-small">
                          <p className="text-body-active text-size-regular">
                            No. DBOS is just a library that runs inside your existing application process. You don't
                            need to provision new servers, change your deployment pipeline, or run separate worker
                            fleets. If you have Postgres, you're ready.
                          </p>
                        </div>
                      </FaqAnswer>
                    </FaqAccordion>
                    <FaqAccordion className="faq_accordion">
                      <FaqQuestion className="faq_question">
                        <h5 className="text-size-medium text-align-left">
                          How is DBOS more reliable than Temporal in production?
                        </h5>
                        <FaqIcon className="faq_icon-wrappper">
                          <div className="icon-embed-small-3 w-embed">
                            <svg
                              width="100%"
                              height="100%"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M25.3333 15.667V16.3336C25.3333 16.7018 25.0349 17.0003 24.6667 17.0003H17V24.667C17 25.0351 16.7015 25.3336 16.3333 25.3336H15.6667C15.2985 25.3336 15 25.0351 15 24.667V17.0003H7.3333C6.96511 17.0003 6.66663 16.7018 6.66663 16.3336V15.667C6.66663 15.2988 6.96511 15.0003 7.3333 15.0003H15V7.33365C15 6.96546 15.2985 6.66699 15.6667 6.66699H16.3333C16.7015 6.66699 17 6.96546 17 7.33365V15.0003H24.6667C25.0349 15.0003 25.3333 15.2988 25.3333 15.667Z"
                                fill="currentColor"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </FaqIcon>
                      </FaqQuestion>
                      <FaqAnswer className="faq_answer">
                        <div className="margin-bottom margin-small">
                          <p className="text-body-active text-size-regular">
                            DBOS has exactly one point of failure: Postgres. Most teams already run Postgres and have
                            established monitoring, backups, and SLAs for it. Temporal adds two new failure domains —
                            the Temporal server and its Cassandra data store — that your team must operate
                            independently.
                          </p>
                        </div>
                      </FaqAnswer>
                    </FaqAccordion>
                    <FaqAccordion className="faq_accordion">
                      <FaqQuestion className="faq_question">
                        <h5 className="text-size-medium text-align-left">
                          What is 'fork' and why does it matter for recovery?
                        </h5>
                        <FaqIcon className="faq_icon-wrappper">
                          <div className="icon-embed-small-3 w-embed">
                            <svg
                              width="100%"
                              height="100%"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M25.3333 15.667V16.3336C25.3333 16.7018 25.0349 17.0003 24.6667 17.0003H17V24.667C17 25.0351 16.7015 25.3336 16.3333 25.3336H15.6667C15.2985 25.3336 15 25.0351 15 24.667V17.0003H7.3333C6.96511 17.0003 6.66663 16.7018 6.66663 16.3336V15.667C6.66663 15.2988 6.96511 15.0003 7.3333 15.0003H15V7.33365C15 6.96546 15.2985 6.66699 15.6667 6.66699H16.3333C16.7015 6.66699 17 6.96546 17 7.33365V15.0003H24.6667C25.0349 15.0003 25.3333 15.2988 25.3333 15.667Z"
                                fill="currentColor"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </FaqIcon>
                      </FaqQuestion>
                      <FaqAnswer className="faq_answer">
                        <div className="margin-bottom margin-small">
                          <p className="text-body-active text-size-regular">
                            Fork lets you restart a workflow from any specific step, either programmatically or from the
                            web UI. This is invaluable when a batch of workflows fail due to a bug or third-party
                            outage: once the issue is resolved, you can resume all affected workflows exactly from the
                            failed step, without rerunning earlier work.
                          </p>
                        </div>
                      </FaqAnswer>
                    </FaqAccordion>
                    <FaqAccordion className="faq_accordion">
                      <FaqQuestion className="faq_question">
                        <h5 className="text-size-medium text-align-left">
                          Is DBOS suitable for latency-sensitive workflows?
                        </h5>
                        <FaqIcon className="faq_icon-wrappper">
                          <div className="icon-embed-small-3 w-embed">
                            <svg
                              width="100%"
                              height="100%"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M25.3333 15.667V16.3336C25.3333 16.7018 25.0349 17.0003 24.6667 17.0003H17V24.667C17 25.0351 16.7015 25.3336 16.3333 25.3336H15.6667C15.2985 25.3336 15 25.0351 15 24.667V17.0003H7.3333C6.96511 17.0003 6.66663 16.7018 6.66663 16.3336V15.667C6.66663 15.2988 6.96511 15.0003 7.3333 15.0003H15V7.33365C15 6.96546 15.2985 6.66699 15.6667 6.66699H16.3333C16.7015 6.66699 17 6.96546 17 7.33365V15.0003H24.6667C25.0349 15.0003 25.3333 15.2988 25.3333 15.667Z"
                                fill="currentColor"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </FaqIcon>
                      </FaqQuestion>
                      <FaqAnswer className="faq_answer">
                        <div className="margin-bottom margin-small">
                          <p className="text-body-active text-size-regular">
                            Yes. This is one of DBOS's key advantages. Because each step checkpoint is a single Postgres
                            write (1–2ms), DBOS is well-suited for interactive or otherwise latency-sensitive workflows.
                            Temporal's async dispatch architecture adds tens to hundreds of milliseconds per step,
                            making it less suitable for these scenarios.
                          </p>
                        </div>
                      </FaqAnswer>
                    </FaqAccordion>
                    <FaqAccordion className="faq_accordion">
                      <FaqQuestion className="faq_question">
                        <h5 className="text-size-medium text-align-left">What database does DBOS require?</h5>
                        <FaqIcon className="faq_icon-wrappper">
                          <div className="icon-embed-small-3 w-embed">
                            <svg
                              width="100%"
                              height="100%"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M25.3333 15.667V16.3336C25.3333 16.7018 25.0349 17.0003 24.6667 17.0003H17V24.667C17 25.0351 16.7015 25.3336 16.3333 25.3336H15.6667C15.2985 25.3336 15 25.0351 15 24.667V17.0003H7.3333C6.96511 17.0003 6.66663 16.7018 6.66663 16.3336V15.667C6.66663 15.2988 6.96511 15.0003 7.3333 15.0003H15V7.33365C15 6.96546 15.2985 6.66699 15.6667 6.66699H16.3333C16.7015 6.66699 17 6.96546 17 7.33365V15.0003H24.6667C25.0349 15.0003 25.3333 15.2988 25.3333 15.667Z"
                                fill="currentColor"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </FaqIcon>
                      </FaqQuestion>
                      <FaqAnswer className="faq_answer">
                        <div className="margin-bottom margin-small">
                          <p className="text-body-active text-size-regular">
                            DBOS works with any Postgres-compatible database, including Amazon Aurora, Supabase, Neon,
                            and standard Postgres. If your application already connects to Postgres, no additional
                            database infrastructure is required.
                          </p>
                        </div>
                      </FaqAnswer>
                    </FaqAccordion>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_cta">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large padding-top">
              <div className="cta_card is-major">
                <div className="max-width-xlarge">
                  <div className="cta_container">
                    <div className="margin-bottom margin-xsmall">
                      <h2 className="heading-style-h2">Less infrastructure. Less cost. Same durability.</h2>
                    </div>
                    <div className="max-width-medium">
                      <div className="margin-bottom margin-xsmall">
                        <p className="text-body-active">Get durable workflows without the operational overhead.</p>
                      </div>
                    </div>
                    <div className="button-group">
                      <div data-wf--button--variant="primary-large" className="button-wrapper">
                        <a href="https://console.dbos.dev/" className="button w-inline-block">
                          <div className="text-block-4">Start for free</div>
                          <div className="icon-chevron-right w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="https://docs.dbos.dev/quickstart"
                          target="_blank"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">
                            Read our quickstart
                          </div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
    </SiteLayout>
  );
}
